/**
 * Created by vtbelo on 09.08.2022
 */

cc.CellScrollAction = function (cell, params) {
    this._cellPos = { x: cell.x, y: cell.y };
    const targetNode = Map2d.currentMap.getMapView().getCell(this._cellPos.x, this._cellPos.y);
    
    cc.ScrollAction.prototype.constructor.call(this, targetNode, params);
};

cc.CellScrollAction.prototype = Object.assign(Object.create(cc.ScrollAction.prototype), {
    constructor: cc.CellScrollAction
});